<report-filter
  showCostCenters='true'
  showFacilities='true'
  showShiftBlocks='true'
  showPeriodEndDateSelection='true'
  defaultPayPeriodsBack=4
  reportType='ancillary'
  ancillaryType='total'
  [(defaultFilter)]="filters"
  (filterUpdated)="filterUpdated($event)">
</report-filter>

<table class="reportArea">
 <tr>
    <td class="reportPanel">
    <smt-performancereport
      [filtersUpdated]='eventObservable'
      [(reportFilters)]='filters'>
    </smt-performancereport>
  </td>
  <td class="reportPanel">    
    <smt-totaluostrendsreport
      [filtersUpdated]='eventObservable' 
      [(reportFilters)]='filters'>
    </smt-totaluostrendsreport>
  </td>
 </tr>
</table>
<table class="reportArea bottomReportArea">
 <tr>
  <td id='smt-measures-panel' class="reportPanel">
    <smt-measures-report
      [filtersUpdated]='eventObservable'
      [(reportFilters)]='filters'>
    </smt-measures-report>
  </td>
  <td class="reportPanel smt-variance-panel">
    <smt-reasonsforvariancereport
      [filtersUpdated]='eventObservable'
      [(reportFilters)]='filters'>
    </smt-reasonsforvariancereport>
  </td>
 </tr>
</table>
